"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTANTS = void 0;
const CONSTANTS = exports.CONSTANTS = {
  GET_INAPP_NAV_SUCCESS: 'GET_INAPP_NAV_SUCCESS',
  GET_NAVIGATION: 'GET_NAVIGATION',
  GET_NAVIGATION_FULFILLED: 'GET_NAVIGATION_FULFILLED',
  ON_INAPP_SELECT: 'ON_INAPP_SELECT',
  STAGE_URL: 'https://customer.staging.weir',
  PROD_URL: 'https://your.weir',
  APP_NAME: '/identity'
};